import { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { Helmet } from 'react-helmet';

import { compose } from 'redux';
import { setPageTitle } from '../../actions/routes';

class PageTitle extends PureComponent {
  componentDidMount() {
    this.props.setPageTitle(this.getHeadline());
  }

  componentDidUpdate() {
    this.props.setPageTitle(this.getHeadline());
  }

  getHeadline() {
    if (this.props.headline) {
      return this.props.intl.formatMessage(this.props.headline);
    }
    return this.getTitle();
  }

  getTitle() {
    return (
      this.props.children && this.props.intl.formatMessage(this.props.children)
    );
  }

  render() {
    return (
      <Helmet>
        <title>{this.getTitle()}</title>
      </Helmet>
    );
  }
}

PageTitle.propTypes = {
  setPageTitle: PropTypes.func.isRequired,
  children: PropTypes.shape({
    id: PropTypes.string.isRequired,
    defaultMessage: PropTypes.string.isRequired,
  }),
  headline: PropTypes.shape({
    id: PropTypes.string.isRequired,
    defaultMessage: PropTypes.string.isRequired,
  }),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

PageTitle.defaultProps = {
  children: null,
  headline: null,
};

const mapDispatchToProps = (dispatch) => ({
  setPageTitle: (title) => dispatch(setPageTitle(title)),
});

export default compose(
  injectIntl,
  connect(null, mapDispatchToProps)
)(PageTitle);
